// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"523":"cb1608f2","832":"component---src-components-templates-people-js"}[chunkId] + "-" + {"523":"10b65562988844fbbd56","832":"eee1a06546dcf94c8b1f"}[chunkId] + ".js";
};